import { memo, useMemo } from "react";

import { Box, Typography } from "@mui/material";

import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

/**
 * =========================================================
 * ✅ ASKOMA PERIOD NAVIGATOR
 * =========================================================
 */
function AskomaPeriodNavigator({ viewMode, viewOffset, setViewOffset }) {
  const theme = useTheme();

  const label = useMemo(() => {
    const now = new Date();

    if (viewMode === "today") {
      const date = new Date(now);
      date.setDate(date.getDate() + viewOffset);

      return date.toLocaleDateString();
    }

    if (viewMode === "week") {
      const date = new Date(now);
      date.setDate(date.getDate() + viewOffset * 7);

      return `KW ${getWeekNumber(date)}`;
    }

    if (viewMode === "month") {
      const date = new Date(now);
      date.setMonth(date.getMonth() + viewOffset);

      return date.toLocaleDateString([], {
        month: "long",
        year: "numeric",
      });
    }

    if (viewMode === "year") {
      return String(now.getFullYear() + viewOffset);
    }

    return `Alle Daten (${viewOffset})`;
  }, [viewMode, viewOffset]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0,
      }}
    >
      <KsbActionButton
        label={<ArrowLeft />}
        icon={<ArrowLeft />}
        onClick={() => setViewOffset((prev) => prev - 1)}
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": { bgcolor: theme.palette.primary.dark },
        }}
      />

      <Typography
        sx={{
          minWidth: 100,
          textAlign: "center",
          fontWeight: 400,
        }}
      >
        {label}
      </Typography>

      <KsbActionButton
        label={<ArrowRight />}
        icon={<ArrowRight />}
        onClick={() => setViewOffset((prev) => prev + 1)}
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": { bgcolor: theme.palette.primary.dark },
        }}
      />
    </Box>
  );
}

function getWeekNumber(date) {
  const target = new Date(date.valueOf());
  const dayNr = (date.getDay() + 6) % 7;

  target.setDate(target.getDate() - dayNr + 3);

  const firstThursday = target.valueOf();

  target.setMonth(0, 1);

  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
  }

  return 1 + Math.ceil((firstThursday - target) / 604800000);
}

export default memo(AskomaPeriodNavigator);
